import type React from 'react';

import { Grid } from '@change/ds-layout/Grid';

import { ChangeIcon } from '../shared/components/ChangeIcon';
import { DismissButton } from '../shared/components/DismissButton';
import { useBanner } from '../shared/hooks/useBanner';

import { Content } from './components/Content';

type Props = {
	sourceLocation: string;
	setBannerClosed: () => void;
	bottomOffsetPx?: number;
};

export const IOSBanner: React.FC<Props> = ({ sourceLocation, setBannerClosed, bottomOffsetPx }) => {
	const {
		actions: { onClickClose, onClickDownload },
	} = useBanner({ sourceLocation, setBannerClosed });

	return (
		<div
			id="app-download-bottom-banner"
			className="text-typography-strong dark:bg-background-raised border-stroke-weaker bg-gradient-background-light-1 fixed bottom-0 left-0 z-30 block w-full border border-solid py-4 shadow-[0px_10px_20px_0px_rgba(24,25,31,0.1)] md:hidden dark:bg-none"
			style={{ bottom: bottomOffsetPx ? `${bottomOffsetPx}px` : undefined }}
			data-testid="app-download-bottom-banner"
			role="alert"
		>
			<DismissButton className="fixed top-auto right-1.5 -mt-2" onClick={onClickClose} />
			<Grid>
				<div className="col-span-4 mr-8 grid grid-cols-[auto_1fr] items-start gap-4">
					<ChangeIcon />
					<Content onClickDownload={onClickDownload} />
				</div>
			</Grid>
		</div>
	);
};
